// CONSTANTS
import { US_COUNTRY_CODE } from '../constants'

// TYPES
import {
  CreateProfileRequest,
  PortableAddress,
  ProfileData,
  ProfileDetailsResponse,
} from '@/types'

/**
 * Formats given data for request to create or edit a profile
 */
export function formatProfileRequestBody(
  profileData: ProfileData,
  isEditing?: boolean,
) {
  const {
    profilePhoto,
    coverPhoto,
    selectedContactInfo = {},
    selectedLocationDisplayPreference,
    businessDescription,
    businessAddress = {} as PortableAddress,
    contactInfo = {},
    profilePublished = true,
    ...remainingValues
  } = profileData

  const { businessEmail, businessWebsiteUrl, unformattedBusinessPhoneNumber } =
    contactInfo

  let request = { ...remainingValues } as CreateProfileRequest

  const safeBusinessAddress = {
    ...businessAddress,
    countryCode: businessAddress.countryCode || US_COUNTRY_CODE,
  }
  request.businessAddress = safeBusinessAddress

  if (unformattedBusinessPhoneNumber) {
    request.businessPhoneNumber = unformattedBusinessPhoneNumber
  }

  if (businessDescription === null || businessDescription) {
    request.businessDescription = businessDescription
  }

  if (businessEmail) {
    request.businessEmail = businessEmail
  }

  if (businessWebsiteUrl) {
    request.businessWebsiteUrl = businessWebsiteUrl
  }

  if (profilePhoto) {
    request.businessProfilePictureUrl = profilePhoto
  } else if (profilePhoto === '' || profilePhoto === null) {
    request.businessProfilePictureUrl = null
  }

  if (coverPhoto) {
    request.businessProfileCoverPhotoUrl = coverPhoto
  } else if (coverPhoto === '' || coverPhoto === null) {
    request.businessProfileCoverPhotoUrl = null
  }

  const profilePreferences = {
    profilePublished,
  } as ProfileDetailsResponse['profilePreferences']

  if (selectedLocationDisplayPreference) {
    profilePreferences.locationDisplayPreference =
      selectedLocationDisplayPreference
  }

  if (
    selectedContactInfo.businessPhoneNumber ||
    selectedContactInfo.businessPhoneNumber === null
  ) {
    profilePreferences.phoneNumberDisplay =
      !!selectedContactInfo.businessPhoneNumber
  }

  if (
    selectedContactInfo.businessEmail ||
    selectedContactInfo.businessEmail === null
  ) {
    profilePreferences.emailAddressDisplay = !!selectedContactInfo.businessEmail
  }

  if (
    selectedContactInfo.businessWebsiteUrl ||
    selectedContactInfo.businessWebsiteUrl === null
  ) {
    profilePreferences.websiteDisplay = !!selectedContactInfo.businessWebsiteUrl
  }

  if (isEditing) {
    request = { ...request, ...profilePreferences }
  } else {
    request.profilePreferences = profilePreferences
  }

  return request
}
